import { Colours, Sizes, Fonts } from '../../../style_helpers'

const hoverShadowStyle = {
  marginTop: '-3px',
  marginBottom: '3px',
  WebkitBoxShadow: `0px 5px 15px 0px rgba(0, 0, 0, 0.15)`,
  MozBoxShadow: `0px 5px 15px 0px rgba(0, 0, 0, 0.15)`,
  boxShadow: `0px 5px 15px 0px rgba(0, 0, 0, 0.15)`
}

const clickedShadowStyle = {
  marginTop: 0,
  marginBottom: 0,
  WebkitBoxShadow: `none`,
  MozBoxShadow: `none`,
  boxShadow: `none`
}

export default function (props) {
  return {
    container: {
      base: {
        cursor: 'pointer',
        height: '100%'
      },

      inline: {
        display: 'inline-block'
      },

      fullWidth: {
        width: '100%'
      }
    },

    base: {
      position: 'relative',
      fontFamily: Fonts('gibson'),
      display: 'block',
      width: '100%',
      borderRadius: '5px',
      margin: 0,
      border: `2px solid transparent`,
      textDecoration: 'none',
      transition: 'background-color 200ms, border 200ms, color 200ms, box-shadow 200ms'
    },

    inline: {
      display: 'inline-block',
      width: 'auto'
    },

    // Box shadow provides an alternative way to display an 'outline'
    // but it also conforms to button borderRadius
    focused: {
      boxShadow: `0 0 0 3px ${Colours('berryBlue', '200')}`
    },

    buttonAlignment: {
      left: { textAlign: 'left' },
      center: { textAlign: 'center' },
      right: { textAlign: 'right' }
    },

    buttonSizes: {
      small: {
        base: {
          fontSize: Sizes(0),
          height: Sizes(10),
          lineHeight: Sizes(10),
          minWidth: Sizes(52),
          padding: `0 ${Sizes(0)} 0 ${Sizes(0)}`
        },

        circular: {
          height: Sizes(12),
          width: Sizes(12),
          padding: 0,
          minWidth: Sizes(12)
        }
      },

      medium: {
        base: {
          fontSize: Sizes(0),
          height: Sizes(12),
          lineHeight: Sizes(12),
          minWidth: Sizes(67),
          padding: `0 ${Sizes(2)} 0 ${Sizes(2)}`
        },

        circular: {
          height: Sizes(22),
          width: Sizes(22),
          padding: 0,
          minWidth: Sizes(22)
        }
      },

      big: {
        base: {
          fontSize: Sizes(2),
          height: Sizes(12),
          lineHeight: Sizes(12),
          minWidth: Sizes(67),
          padding: `0 ${Sizes(0)} 0 ${Sizes(0)}`
        },

        circular: {
          height: Sizes(20),
          width: Sizes(20),
          padding: 0,
          minWidth: Sizes(20)
        }
      },

      large: {
        base: {
          fontSize: Sizes(4),
          height: Sizes(12),
          lineHeight: Sizes(12),
          minWidth: Sizes(70),
          padding: `0 ${Sizes(0)} 0 ${Sizes(0)}`
        },

        circular: {
          height: Sizes(24),
          width: Sizes(24),
          padding: 0,
          minWidth: Sizes(24)
        }
      }
    },

    buttonTypes: {
      alpha: {
        base: {
          color: Colours('white', '300'),
          backgroundColor: Colours(props.colour, '300')
        },

        hover: {
          tone: {
            backgroundColor: Colours(props.colour, '400')
          },

          shadow: hoverShadowStyle
        },

        clicked: {
          tone: {
            backgroundColor: Colours(props.colour, '500')
          },

          shadow: clickedShadowStyle
        }
      },

      bravo: {
        base: {
          color: Colours('grey', '500'),
          backgroundColor: Colours('white', '300')
        },

        hover: {
          tone: {
            color: Colours(props.colour, '300')
          },

          shadow: hoverShadowStyle
        },

        clicked: {
          tone: {
            color: Colours('grey', '500')
          },

          shadow: clickedShadowStyle
        }
      },

      charlie: {
        base: {
          color: Colours(props.colour, '300'),
          backgroundColor: 'transparent',
          textDecoration: props.underlined ? 'underline' : 'none'
        },

        hover: {
          tone: {
            color: Colours(props.colour, '400')
          },

          shadow: {
            color: Colours(props.colour, '400')
          }
        },

        clicked: {
          tone: {
            color: Colours(props.colour, '500')
          },

          shadow: {
            color: Colours(props.colour, '500')
          }
        }
      },

      delta: {
        base: {
          color: Colours(props.colour, '300'),
          backgroundColor: 'transparent',
          border: `2px solid ${Colours(props.colour, '300')}`
        },

        hover: {
          tone: {
            color: Colours(props.colour, '400'),
            border: `2px solid ${Colours(props.colour, '400')}`
          },

          shadow: hoverShadowStyle
        },

        clicked: {
          tone: {
            color: Colours(props.colour, '500'),
            border: `2px solid ${Colours(props.colour, '500')}`
          },

          shadow: clickedShadowStyle
        }
      },

      circular: {
        base: {
          borderRadius: '50%',
          backgroundColor: Colours(props.colour, '300')
        },

        hover: {
          tone: {
            backgroundColor: Colours(props.colour, '400')
          },

          shadow: hoverShadowStyle
        },

        clicked: {
          tone: {
            backgroundColor: Colours(props.colour, '500')
          },

          shadow: clickedShadowStyle
        }
      }
    },

    disabled: {
      base: {
        cursor: 'not-allowed',
        color: Colours('grey', '200'),
        border: '2px solid transparent'
      },

      alpha: {
        backgroundColor: Colours('grey', '100')
      },

      bravo: {
        backgroundColor: Colours('grey', '100')
      },

      charlie: {
        backgroundColor: 'transparent'
      },

      delta: {
        backgroundColor: 'transparent',
        color: Colours('grey', '200'),
        border: `2px solid ${Colours('grey', '200')}`
      },

      circular: {
        backgroundColor: Colours('grey', '100')
      }
    },

    icon: {
      base: {
        verticalAlign: 'middle',
        height: Sizes(0)
      },

      alpha: {
        base: {
          color: Colours('white', '300')
        }
      },

      bravo: {
        base: {
          color: Colours('grey', '500')
        },

        hover: {
          color: props.hoverType === 'tone' ? Colours(props.colour, '300') : Colours('grey', '500')
        },

        clicked: {
          color: Colours('grey', '500')
        }
      },

      charlie: {
        base: {
          color: Colours(props.colour, '300')
        },

        hover: {
          color: Colours(props.colour, '400')
        },

        clicked: {
          color: Colours(props.colour, '500')
        }
      },

      delta: {
        base: {
          color: Colours(props.colour, '300')
        },

        hover: {
          color: Colours(props.colour, '400')
        },

        clicked: {
          color: Colours(props.colour, '500')
        }
      },

      circular: {
        base: {
          color: Colours('white', '300'),
          marginLeft: 0,
          marginRight: 0
        },

        small: {
          height: Sizes(-2)
        },

        medium: {
          height: Sizes(2)
        },

        large: {
          height: Sizes(5)
        }
      },

      left: {
        marginRight: Sizes(-5)
      },

      right: {
        marginLeft: Sizes(-5)
      },

      disabled: {
        base: {
          color: Colours('grey', '200')
        },

        delta: {
          color: Colours('grey', '200')
        }
      }
    }
  }
}
